import {useProposition} from '@myparcel-frontend/proposition';
import {version} from '../../package.json';
import useAccount from '@/composables/useAccount/useAccount';
import useShop from '@/composables/useShop/useShop';
import {useEnvironmentStore} from '@/env/useEnvironmentStore';

/**
 * Default logger to New Relic.
 *
 * Logs to New Relic via `noticeError` outside dev mode, otherwise falls back to `console.error`.
 * Account id, shop id, proposition and app version are appended automatically.
 *
 * @param error - The JS error to log.
 * @param $customAttributes - Custom attributes to show in New Relic. Must include
 *   `_myparcel_extra_info`; every other key must be prefixed with `_myparcel_`.
 */
const logToMonitor = (
  error: Error,
  $customAttributes: {_myparcel_extra_info: string} & Record<`_myparcel_${string}`, unknown>,
): void => {
  const {environment} = useEnvironmentStore();
  const {account} = useAccount();
  const {currentShop} = useShop();
  const {proposition} = useProposition();

  const customAttributes = {
    ...$customAttributes,
    _myparcel_account_id: account.value?.id,
    _myparcel_shop_id: currentShop.value?.id,
    _myparcel_proposition: proposition.value?.proposition.name,
    _myparcel_version: version,
  };

  if (!environment.devMode && window.newrelic) {
    window.newrelic.noticeError(error, customAttributes);
  } else {
    console.error(error, customAttributes);
  }
};

export default logToMonitor;
